"use strict";

(function () {
  'use strict';

  angular.module('main-nav', ['ui.router']).component('mainNav', {
    bindings: {
      navItems: '<'
    },
    templateUrl: 'components/main-nav/main-nav.html',
    controller: mainNavCtrl
  });
  mainNavCtrl.$inject = ['$state'];
  /* @ngInject */

  function mainNavCtrl($state) {
    var vm = this;

    vm.isActive = function (state) {
      return $state.includes(state.split('.')[0]);
    };
  }
})();